import { useEffect, useRef } from 'react';
import { useScript } from 'usehooks-ts';

import type { QuestionnairePanelProps } from './types.ts';

import { useEnvironmentConfig } from '#src/hooks/environment.tsx';
import { useQueryParam } from '#src/hooks/queryParams.ts';

export const QuestionnairePanelLoader = ({
  props,
}: {
  props: QuestionnairePanelProps;
}) => {
  const {
    baseUrls: { panels },
  } = useEnvironmentConfig();

  const [panelVersion] = useQueryParam('v-panel');
  const version = panelVersion ? `/${panelVersion}` : '';

  const status = useScript(`${panels}${version}/SeekApi.js`);

  const node = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (window.SeekApi && node?.current) {
      window.SeekApi.render(node.current, 'questionnaire', props);
    }
  }, [status, props]);

  if (
    status === 'error' ||
    (status === 'ready' && typeof window.SeekApi === 'undefined')
  ) {
    return null;
  }

  return <div ref={node} />;
};
